import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    ElementRef,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ExpandModalDialog } from 'app/modules/well-integrity-management/component/expand-modal/expand-modal.component';
import { WellMaintenanceResponse } from '../../model/well-integrity-management.type';

@Component({
    selector: 'well-maintenance',
    templateUrl: './well-maintenance.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule],
    styleUrls: ['./well-maintenance.component.scss'],
})
export class WellMaintenanceComponent implements OnChanges {
    @Input() expandIcon: any;
    @Input() data: WellMaintenanceResponse;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly dialog: MatDialog,
        private readonly cdr: ChangeDetectorRef,
        private readonly destroyRef: DestroyRef
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data'] && this.data?.data?.items) {
            this.cdr.markForCheck();
        }
    }

    openDialog(title: string, componentName: string, functionName: string) {
        const component = document.getElementById(componentName);

        const dialogRef = this.dialog.open(ExpandModalDialog, {
            data: {
                title: title,
                viewComponent: component,
                functionName: functionName,
                apiData: this.data,
            },
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((result) => {
                console.log(`Dialog result: ${result}`);
            });
    }
}
